//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The invoice type to show in clients.
*
* 
*  * INVOICE value: 1 - invoice 
*  * CREDIT value: 2 - credit 
*  * CANCELLATION value: 3 - cancellation 
*  * EVENT_CLEARING value: 4 - event clearing 
*  * PRODUCTCOST_CLEARING value: 5 - product cost clearing 
*/
@Serializable
enum class InvoiceType(val value: kotlin.Int) {

    @SerialName(value = "1")
    INVOICE(1),

    @SerialName(value = "2")
    CREDIT(2),

    @SerialName(value = "3")
    CANCELLATION(3),

    @SerialName(value = "4")
    EVENT_CLEARING(4),

    @SerialName(value = "5")
    PRODUCTCOST_CLEARING(5);

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value.toString()

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is InvoiceType) "$data" else null

    /**
    * Returns a valid [InvoiceType] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): InvoiceType? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

